<template>
  <div>
    <page-title>Create New User</page-title>
    <div>
      <h4>Create a new user and add them to the portal</h4>
    </div>
    <div>
      <form action method="POST" @submit.prevent="createUser">
        <validation-observer
          ref="adminNewUserObserver"
          tag="div"
          v-slot="{invalid, valid, untouched, errors}"
        >
          <div class="columns flex-column has-margin-top-20">
            <div class="column is-6">
              <b-field
                :label="'Select User Type'"
                :type="{'is-danger': errors.length }"
                :message="errors[0]"
                v-if="current_user === 'nimasaAdmin'"
              >
                <multiselect
                  v-model="user_type"
                  deselect-label="Selected"
                  track-by="id"
                  required
                  label="label"
                  placeholder="Select a User Type"
                  :name="'create user type'"
                  :options="nimasaAdminUser"
                  :searchable="true"
                  :allow-empty="true"
                >
                  <template slot="singleLabel" slot-scope="{ option }">{{ option.label }}</template>
                </multiselect>
              </b-field>

              <!-- For hudsontrident admin -->
              <b-field
                :label="'Select User Type'"
                :type="{'is-danger': errors.length }"
                :message="errors[0]"
                v-if="current_user === 'hudsontridentAdmin'"
              >
                <multiselect
                  v-model="user_type"
                  deselect-label="Selected"
                  track-by="id"
                  label="label"
                  required
                  placeholder="Select a User Type"
                  :name="'create user type'"
                  :options="hudsontridentUser"
                  :searchable="true"
                  :allow-empty="true"
                >
                  <template slot="singleLabel" slot-scope="{ option }">{{ option.label }}</template>
                </multiselect>
              </b-field>
            </div>

            <div v-if="user_type && user_type.value === 'PORT_USER'" class="column is-6">
              <b-field
                :label="'New User Port'"
                :type="{'is-danger': errors.length }"
                :message="errors[0]"
              >
                <multiselect
                  v-model="selectedPort"
                  deselect-label="Port must be selected"
                  track-by="id"
                  label="name"
                  placeholder="Select a Port"
                  :name="'port of discharge'"
                  :options="ports"
                  :searchable="true"
                  :allow-empty="false"
                  @select="(option,id) => updateUserPortID(option)"
                >
                  <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                </multiselect>
              </b-field>
            </div>
            <!-- Name of user -->
            <div class="column is-6">
              <input-with-validation
                :name="'name'"
                :errorLabel="'name'"
                :label="'Full Name'"
                rules="required"
                v-model="full_name"
                :type="'text'"
                :vid="'name'"
              ></input-with-validation>
            </div>

            <!-- Username of new user -->
            <div class="column is-6">
              <input-with-validation
                :name="'name'"
                :errorLabel="'name'"
                :label="'Username'"
                rules="required"
                v-model="user_name"
                :type="'text'"
                :vid="'name'"
              ></input-with-validation>
            </div>

            <!-- Email of user -->
            <div class="column is-6">
              <input-with-validation
                :name="'email'"
                :errorLabel="'email'"
                :label="'Email Address'"
                rules="required|email"
                v-model="email"
                :type="'text'"
                :vid="'email'"
              ></input-with-validation>
            </div>

            <!-- Submit Button -->
            <div class="column is-6">
              <button
                class="button is-primary is-full-width has-margin-bottom-20"
                :class="{'is-loading': loading, 'is-disabled': loading}"
              >
                <span>Create User</span>
              </button>
            </div>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>


<script>
import InputWithValidation from "@/modules/commonModule/components/formInputs/inputWithValidation";
import { ROOT_MUTATION_TYPES } from "@/store/mutation-types.js";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("admin");
import CreateUserMutation from "../api/graphql/mutations/CreateUserMutations";
import { async } from "q";
import {
  mapGetters as mapRootGetters,
  mapMutations as mapRootMutations
} from "vuex";
import GetPortsQuery from "@/modules/commonModule/api/graphql/queries/GetPorts";

export default {
  name: "admin-new-user",
  components: {
    InputWithValidation,
    ValidationObserver,
    Multiselect
  },
  data() {
    return {
      full_name: "",
      user_name: "",
      email: "",
      selectedPort: null,
      ports: null,
      port_id: null,
      user_type: null,
      current_user: null,
      loading: false,
      nimasaAdminUser: [
        { id: 1, value: "NIMASA_USER", label: "NIMASA AGENT" },
        { id: 2, value: "NIMASA_MANAGER", label: "NIMASA MANAGER" }
      ],
      hudsontridentUser: [
        { id: 1, value: "PORT_USER", label: "Port User" },
        { id: 1, value: "NIMASA_ADMIN", label: "NIMASA Admin User" }
      ]
    };
  },

  mounted() {
    /**
     * Get the right user
     */
    if (this.isNimasaAdmin) {
      this.current_user = "nimasaAdmin";
    }

    if (this.isHudsontridentUser) {
      this.current_user = "hudsontridentAdmin";
    }

    /**
     * Get the ports
     */

    if (!this.ports) {
      this.ports = this.getPorts.data;
    }
  },
  computed: {
    ...mapGetters({
      isNimasaAdmin: "isNimasaAdmin",
      isHudsontridentUser: "isHudsontridentUser"
    }),
    ...mapRootGetters({
      getPorts: "getPorts"
    }),
    createUser() {
      if (this.user_type.value === "PORT_USER") {
        this.loadPortsFromAPI();
        return this.createPortUser;
      }
      if (this.user_type.value === "NIMASA_ADMIN") {
        return this.createNimasaAdminUser;
      }
      if (this.user_type.value === "NIMASA_MANAGER" || "NIMASA_AGENT") {
        return this.createNimasaUser;
      }
    }
  },
  methods: {
    ...mapRootMutations({
      updatePorts: ROOT_MUTATION_TYPES.SAVE_PORTS
    }),

    /**
     * Create Port User
     */
    createPortUser: async function() {
      const isValid = await this.$refs.adminNewUserObserver.validate();
      if (!isValid) {
        return;
      }

      const newPortUserInput = {
        full_name: this.full_name,
        user_name: this.user_name,
        email: this.email,
        port_id: this.port_id,
        user_type: this.user_type.value
      };

      this.loading = true;

      this.$apollo
        .mutate({
          mutation: CreateUserMutation.PortUserMutation,
          variables: {
            input: newPortUserInput
          }
        })
        .then(response => {
          const port_user_name = response.data.CreatePortUser.full_name;
          this.$toast.open({
            duration: 6000,
            message: `A verification email has been sent to the provided e-mail address for ${port_user_name.toUpperCase()}.`,
            type: "is-success"
          });
          setTimeout(() => this.$router.go({ name: "admin-new-user" }), 6000);
        })
        .catch(err => {
          this.$toast.open({
            duration: 5000,
            message: "Could not create user at the moment, try again later",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * Create NIMASA Admin User
     */
    createNimasaAdminUser: async function() {
      const isValid = await this.$refs.adminNewUserObserver.validate();
      if (!isValid) {
        return;
      }

      const newAdminUserInput = {
        full_name: this.full_name,
        user_name: this.user_name,
        email: this.email,
        user_type: this.user_type.value
      };

      this.loading = true;

      this.$apollo
        .mutate({
          mutation: CreateUserMutation.NimasaAdminUserMutation,
          variables: {
            input: newAdminUserInput
          }
        })
        .then(response => {
          const admin_user_name = response.data.CreateNimasaAdminUser.full_name;
          this.$toast.open({
            duration: 8000,
            message: `A verification email has been sent to the provided e-mail address for ${admin_user_name.toUpperCase()}.`,
            type: "is-success"
          });
          setTimeout(() => this.$router.go({ name: "admin-new-user" }), 8000);
        })
        .catch(err => {
          this.$toast.open({
            duration: 5000,
            message: "Could not create user at the moment, try again later",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * Create NIMASA User.
     */

    createNimasaUser: async function() {
      const isValid = await this.$refs.adminNewUserObserver.validate();
      if (!isValid) {
        return;
      }

      const newNimasaUserInput = {
        full_name: this.full_name,
        email: this.email,
        user_name: this.user_name,
        user_type: this.user_type.value
      };

      this.loading = true;

      this.$apollo
        .mutate({
          mutation: CreateUserMutation.NimasaUserMutation,
          variables: {
            input: newNimasaUserInput
          }
        })
        .then(response => {
          const nimasa_user_name = response.data.CreateNimasaUser.full_name;
          this.$toast.open({
            duration: 8000,
            message: `A verification email has been sent to the provided e-mail address for ${nimasa_user_name.toUpperCase()}.`,
            type: "is-success"
          });
          setTimeout(() => this.$router.go({ name: "admin-new-user" }), 8000);
        })
        .catch(err => {
          this.$toast.open({
            duration: 5000,
            message: "Could not create user at the moment, try again later",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateUserPortID(option) {
      this.port_id = +option.id;
    },
    loadPortsFromAPI: function() {
      this.isLoading = true;

      this.$apollo
        .query({
          query: GetPortsQuery
        })
        .then(response => {
          const ports = response.data.ports;
          this.updatePorts(ports);
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            message: "Failed to load list of ports",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>